import _Object$values from "@babel/runtime-corejs3/core-js-stable/object/values";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

var _dec, _class, _class2, _temp;

import React, { Component, Fragment } from 'react';
import types from 'prop-types';
import { autobind } from 'core-decorators';
import Tether, { PLACEMENTS } from '@rexlabs/tether';
import { styled, StyleSheet, keyframes } from '@rexlabs/styling';
import Arrow from './arrow';
import { noop, isString } from 'lodash';
var enterAnimation = keyframes({
  '0%': {
    opacity: 0,
    transform: 'scale3d(0.7,0.7,0.7)'
  },
  '100%': {
    opacity: 1,
    transform: 'scale3d(1,1,1)'
  }
});
var exitAnimation = keyframes({
  '0%': {
    opacity: 1,
    transform: 'scale3d(1,1,1)'
  },
  '100%': {
    opacity: 0,
    transform: 'scale3d(0.7,0.7,0.7)'
  }
});
var INTERACTIONS = {
  CLICK: 'CLICK',
  HOVER: 'HOVER',
  NONE: 'NONE'
};
var tetherStyles = StyleSheet({
  opening: {
    animation: "".concat(enterAnimation, " forwards normal 0.25s cubic-bezier(.24,.9,.27,1)")
  },
  closing: {
    animation: "".concat(exitAnimation, " forwards normal 0.25s cubic-bezier(.24,.9,.27,1)")
  },
  content: {
    transition: 'none',
    transformOrigin: 'center'
  },
  contentTop: {
    transform: 'translateY(-.8rem)'
  },
  contentBottom: {
    transform: 'translateY(.8rem)'
  },
  contentLeft: {
    transform: 'translateX(-.8rem)'
  },
  contentRight: {
    transform: 'translateX(.8rem)'
  }
});
var defaultStyles = StyleSheet({
  tooltip: {
    display: 'block',
    padding: '1rem',
    minWidth: '10rem',
    boxSizing: 'border-box',
    margin: 0,
    background: 'white',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    position: 'relative',
    zIndex: 3
  },
  container: {
    position: 'relative',
    display: 'inline-block',
    '&:active:focus': {
      outline: 'none'
    }
  },
  clickable: {
    cursor: 'pointer'
  },
  overlay: {
    width: '100%',
    height: '100%',
    position: 'fixed',
    zIndex: 2,
    left: 0,
    top: 0
  }
});
var ControlledTooltip = (_dec = styled(defaultStyles), _dec(_class = autobind(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  _inherits(ControlledTooltip, _Component);

  function ControlledTooltip() {
    var _getPrototypeOf2, _context;

    var _this;

    _classCallCheck(this, ControlledTooltip);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ControlledTooltip)).call.apply(_getPrototypeOf2, _concatInstanceProperty(_context = [this]).call(_context, args)));

    _defineProperty(_assertThisInitialized(_this), "_refs", {});

    return _this;
  }

  _createClass(ControlledTooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.body.addEventListener('click', this.onBodyClick, this.props.useCapture);
      document.body.addEventListener('mousedown', this.onBodyMouseDown, this.props.useCapture);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.body.removeEventListener('click', this.onBodyClick);
      document.body.removeEventListener('mousedown', this.onBodyMouseDown);
    }
  }, {
    key: "onBodyClick",
    value: function onBodyClick(e) {
      var _this$props = this.props,
          isOpen = _this$props.isOpen,
          onBodyClick = _this$props.onBodyClick;

      if (onBodyClick) {
        onBodyClick(e, {
          ref: this.tooltip,
          isOutside: !this.tooltip || !this.tooltip.contains(e.target),
          isOpen: isOpen
        });
      }
    }
  }, {
    key: "onBodyMouseDown",
    value: function onBodyMouseDown(e) {
      var _this$props2 = this.props,
          isOpen = _this$props2.isOpen,
          onBodyMouseDown = _this$props2.onBodyMouseDown;

      if (onBodyMouseDown) {
        onBodyMouseDown(e, {
          ref: this.tooltip,
          isOutside: !this.tooltip || !this.tooltip.contains(e.target),
          isOpen: isOpen
        });
      }
    }
  }, {
    key: "renderContent",
    value: function renderContent(_ref) {
      var placement = _ref.placement;
      var _this$props3 = this.props,
          Content = _this$props3.Content,
          s = _this$props3.styles,
          isOpen = _this$props3.isOpen,
          isClosing = _this$props3.isClosing;
      return React.createElement("div", {
        ref: this.setRef
      }, React.createElement("div", {
        style: {
          position: 'absolute',
          width: '100%',
          height: '100%'
        }
      }), React.createElement("div", s('tooltip'), isString(Content) ? React.createElement(Content, null) : React.createElement(Content, {
        isOpen: isOpen,
        isClosing: isClosing,
        placement: placement
      })));
    }
  }, {
    key: "setRef",
    value: function setRef(ref) {
      this.tooltip = ref;
    }
  }, {
    key: "renderChild",
    value: function renderChild(_ref2) {
      var ref = _ref2.ref;
      var _this$props4 = this.props,
          s = _this$props4.styles,
          children = _this$props4.children,
          isOpen = _this$props4.isOpen,
          onContainerClick = _this$props4.onContainerClick;
      var onlyChild = React.Children.only(children);
      return React.createElement("div", _extends({
        ref: ref,
        tabIndex: 0
      }, s('container', {
        clickable: onContainerClick
      }), {
        style: {
          zIndex: isOpen ? 3 : 0
        },
        onClick: onContainerClick
      }), onlyChild);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          s = _this$props5.styles,
          style = _this$props5.style,
          className = _this$props5.className,
          children = _this$props5.children,
          arrowMargin = _this$props5.arrowMargin,
          placement = _this$props5.placement,
          offset = _this$props5.offset,
          autoFlip = _this$props5.autoFlip,
          Arrow = _this$props5.Arrow,
          Content = _this$props5.Content,
          tetherStyles = _this$props5.tetherStyles,
          isOpen = _this$props5.isOpen,
          isClosing = _this$props5.isClosing,
          distance = _this$props5.distance,
          rest = _objectWithoutProperties(_this$props5, ["styles", "style", "className", "children", "arrowMargin", "placement", "offset", "autoFlip", "Arrow", "Content", "tetherStyles", "isOpen", "isClosing", "distance"]);

      return React.createElement(Fragment, null, isOpen ? React.createElement(Tether, _extends({}, rest, {
        offset: offset,
        styles: tetherStyles,
        arrowMargin: arrowMargin,
        distance: distance,
        placement: placement,
        Content: this.renderContent,
        autoFlip: autoFlip,
        Arrow: Arrow,
        isClosing: isClosing
      }), this.renderChild) : this.renderChild({}));
    }
  }]);

  return ControlledTooltip;
}(Component), _defineProperty(_class2, "PLACEMENTS", PLACEMENTS), _defineProperty(_class2, "INTERACTIONS", INTERACTIONS), _defineProperty(_class2, "CLICK", INTERACTIONS.CLICK), _defineProperty(_class2, "HOVER", INTERACTIONS.HOVER), _defineProperty(_class2, "NONE", INTERACTIONS.NONE), _defineProperty(_class2, "propTypes", {
  /**
   * Content to render inside the tooltip.
   */
  content: types.node,

  /**
   * Tether placement.
   */
  placement: types.oneOf(_Object$values(PLACEMENTS)),

  /**
   * Offset arrow to move it closer towards the middle of the tooltip. Any CSS unit.
   */
  arrowMargin: types.string,

  /**
   * Tooltip distance from button.
   */
  distance: types.string,

  /**
   * Offset the tooltip on its primary axis
   */
  offset: types.string,

  /**
   * Where or not to automatically reposition
   */
  autoFlip: types.bool,

  /**
   * Whether or not the Tether is about to close. Allows you to hook into
   * Tether to display closing animations.
   */
  isClosing: types.bool,

  /**
   * Function that will be run when the tooltip is open and the body is clicked
   */
  onBodyClick: types.func,

  /**
   * Function that will be run when the tooltip content container is clicked
   */
  onContainerClick: types.func
}), _defineProperty(_class2, "defaultProps", {
  arrowMargin: '1.4rem',
  distance: '20px',
  offset: '0px',
  tetherStyles: tetherStyles,
  Arrow: Arrow,
  onBodyClick: noop
}), _temp)) || _class) || _class);
export default ControlledTooltip;